import { axios } from '@/network/util/request'

/**
 * login func
 * parameter: {
 *     companyGroupDomain:''
 *     username: '',
 *     password: ''
 * }
 * @param url
 * @param parameter
 * @returns {*}
 */
export function login(url = '/sys/login', parameter) {
	return axios({
		url: url,
		method: 'post',
		data: parameter,
	})
}

/**
 *
 * @param {*} logoutToken
 */
export function logout(logoutToken) {
	return axios({
		url: '/sys/logout',
		method: 'post',
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			'X-Access-Token': logoutToken,
		},
	})
}
